import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column p-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-5" }, " Password fehlt oder ist falsch. Bitte eingeben. ", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Freischalten ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-key",
  style: {"margin-left":"1.5rem"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

import BaseDialog from "@/components/BaseDialog.vue";
import {setGalleryAuth} from "@/stores/auth";
import {ref} from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  show: {
    type: Boolean
  }
},
  setup(__props) {

const props = __props

const userInputGalleryAuth = ref<string>("")



const storeAuth = () => {
  setGalleryAuth(userInputGalleryAuth.value)
  window.location.reload()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDialog, { show: __props.show }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userInputGalleryAuth).value = $event)),
          type: "password",
          class: "mb-5"
        }, null, 512), [
          [_vModelText, userInputGalleryAuth.value]
        ]),
        _createElementVNode("div", { class: "d-flex justify-content-end align-items-end" }, [
          _createElementVNode("button", {
            class: "button-primary",
            onClick: storeAuth,
            style: {"min-width":"unset","width":"unset"}
          }, _hoisted_5)
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})